type FaqItem = {
    question: string;
    answer: string | React.ReactElement;
};

type FaqSectionProps = {
    faqs: FaqItem[];
};

export function NewFaqSection({ faqs }: FaqSectionProps) {
    return (
        <section
            className='py-12 bg-gray-50 sm:py-16 lg:py-20'
            itemScope
            itemType='https://schema.org/FAQPage'>
            <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='text-center'>
                    <h2 className='text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj'>
                        Frequently Asked Questions
                    </h2>
                </div>

                <div className='max-w-5xl mx-auto mt-10 sm:mt-20'>
                    <div className='flow-root'>
                        <div className='-my-8 divide-y divide-gray-200'>
                            {faqs.map((faq, index) => (
                                <div
                                    key={index}
                                    className='py-8'
                                    itemScope
                                    itemProp='mainEntity'
                                    itemType='https://schema.org/Question'>
                                    <p
                                        className='text-2xl font-bold text-gray-900 font-pj'
                                        itemProp='name'>
                                        {`${String(index + 1).padStart(2, '0')}. ${faq.question}`}
                                    </p>
                                    <div
                                        className='mt-8 text-lg font-normal text-gray-600 font-pj'
                                        itemScope
                                        itemProp='acceptedAnswer'
                                        itemType='https://schema.org/Answer'>
                                        <p itemProp='text'>{faq.answer}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
const defaultFaq: FaqItem[] = [
    {
        question: `What should I do if I can't install the AI Assistant add-in?`,
        answer: (
            <>
                Please raise support request for assistance at&nbsp;
                <a
                    href='https://help.perfectassistant.ai/feedback'
                    className='underline'>
                    help.perfectassistant.ai
                </a>
            </>
        ),
    },
    {
        question: 'How do I cancel my subscription?',
        answer: (
            <>
                You can cancel your subscription at any time.{' '}
                <a
                    href='https://ipirozhenko.onfastspring.com/ai-assistant/account'
                    target='blank'
                    className='underline'>
                    Login onto our payment portal with your email.
                </a>
                &nbsp;Go to subscriptions and click cancel.
            </>
        ),
    },
    {
        question: 'What methods of payment do you accept?',
        answer: `We accept payments via credit or debit
                                    cards, including MasterCard, VISA, American
                                    Express, as well as PayPal.`,
    },
    {
        question: 'Can I get a refund?',
        answer: `Unfortunately, we cannot offer refunds as
                                    costs incurred for hosting and supporting AI
                                    models are extremely high. In turn, our
                                    hosting providers do not let us ask for
                                    refunds for the GPU processing time used to
                                    process your AI requests. This would make it
                                    a loss making endeavor for us. During sign
                                    up you agree to withhold your right to
                                    refund for this reason.`,
    },
    {
        question: 'Is AI Perfect Assistant GDPR compliant?',
        answer: `Yes! We take data privacy seriously and are fully GDPR compliant. 
                                    Your data is encrypted in transit and at rest, we don't store your 
                                    Office documents or emails, and all AI processing happens securely. 
                                    We only collect minimal necessary data for service operation, you have 
                                    full control over your data with the right to access, modify, or delete it 
                                    at any time. Our servers are located in secure data centers within the EU, 
                                    and we never share your data with third parties for marketing purposes. 
                                    Your privacy is our priority!`,
    },
];
export function FaqSection() {
    return <NewFaqSection faqs={defaultFaq} />;
}
